if (!customElements.get('sticky-variant-select')) {
  class StickyProVariantSelect extends HTMLElement {
    constructor() {
      super();
      this.variantData = null;
      this.addEventListener("change", this.onStickyVariantChange.bind(this));
    }

    connectedCallback() {
      // Get variant data from sticky cart's own product JSON
      const stickyCart = this.closest('.product__sticky');
      if (stickyCart) {
        const productJsonElement = stickyCart.querySelector('[data-product-json]');
        if (productJsonElement) {
          try {
            this.variantData = JSON.parse(productJsonElement.textContent);
          } catch (e) {
            console.warn('Could not parse product JSON:', e);
          }
        }
      }
    }

    onStickyVariantChange() {
      this.varOptions = this.querySelector("select");
      let productForms = document.querySelector(
        `#product-sticky-form-${this.dataset.section}`
      );
      let input = productForms.querySelector('input[name="id"]');
      input.value = this.varOptions.value;

      // Update price and image when variant changes
      this.updatePrice();
      this.updateImage();
      this.updateAddToCartButton();
    }

    updatePrice() {
      const priceElement = document.querySelector('.sticky__product-price');
      const variantId = this.varOptions.value;

      if (priceElement && this.variantData && this.variantData.variants) {
        const variant = this.variantData.variants.find(v => v.id == variantId);
        if (variant && variant.price) {
          // Format price using Shopify's money format
          const price = variant.price / 100; // Shopify stores prices in cents
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(price);
          priceElement.textContent = formattedPrice;
        }
      }
    }

    updateImage() {
      const productImage = document.querySelector('.sticky__product-image img');
      const variantId = this.varOptions.value;

      if (productImage && this.variantData && this.variantData.variants) {
        const variant = this.variantData.variants.find(v => v.id == variantId);
        if (variant && variant.featured_image) {
          const newImageUrl = variant.featured_image.src;
          // Update image with proper Shopify CDN size
          const sizedImageUrl = newImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_160x.$1');
          productImage.src = sizedImageUrl;
          productImage.alt = variant.featured_image.alt || this.variantData.title;
        } else if (this.variantData.featured_image) {
          // Fallback to product's main image if variant has no image
          const mainImageUrl = this.variantData.featured_image;
          const sizedImageUrl = mainImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_160x.$1');
          productImage.src = sizedImageUrl;
        }
      }
    }

    updateAddToCartButton() {
      const selectedOption = this.varOptions.options[this.varOptions.selectedIndex];
      const addToCartButton = document.querySelector('.sticky__add-to-cart button');

      if (addToCartButton && selectedOption) {
        const isDisabled = selectedOption.disabled;
        addToCartButton.disabled = isDisabled;

        if (isDisabled) {
          addToCartButton.textContent = window.productStrings?.soldOut || 'Sold out';
        } else {
          addToCartButton.textContent = window.productStrings?.addToCart || 'Add to cart';
        }
      }
    }
  }
  customElements.define("sticky-variant-select", StickyProVariantSelect);
}

if (!window.stickyScrollInitialized) {
  window.stickyScrollInitialized = true;

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      window.stickyScroll();
    });
    document.addEventListener("shopify:section:select", (event) => {
      window.stickyScroll();
    });
    document.addEventListener("shopify:section:deselect", (event) => {
      window.stickyScroll();
    });
  }

  window.stickyScroll = () => {
    const BuyButtonForm = document.querySelector(".product_buy_button_form");
    const productStickyWrapper = document.querySelector(".product__sticky");

    if (!BuyButtonForm || !productStickyWrapper) return;

    // Flag to track if user manually closed the sticky cart
    let stickyCartClosed = false;

    // Close button functionality
    const closeButton = productStickyWrapper.querySelector('[data-sticky-close]');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        productStickyWrapper.classList.remove('sticky');
        document.body.classList.remove("sticky__cart");
        // Set flag to prevent sticky cart from appearing again
        stickyCartClosed = true;
      });
    }

    // Scroll detection logic
    let scrollTimeout;
    window.addEventListener("scroll", function () {
      // Don't show sticky cart if user has closed it
      if (stickyCartClosed) return;

      // Debounce for better performance
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        let BuyBUttonOffset = TopOffset(BuyButtonForm);
        let BuyBUttonTopffset = BuyBUttonOffset.top;

        if (window.scrollY > BuyBUttonTopffset) {
          productStickyWrapper.classList.add("sticky");
          document.body.classList.add("sticky__cart");
        } else {
          productStickyWrapper.classList.remove("sticky");
          document.body.classList.remove("sticky__cart");
        }
      }, 10);
    });
  };

  window.stickyScroll();
}
